import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/mintview/comic/scroll.svg';
import _imports_1 from '@/assets/mintview/comic/3.jpg';
import _imports_2 from '@/assets/icons/new-tab-full.svg';
const _hoisted_1 = {
  class: "success-comic-page-container"
};
const _hoisted_2 = {
  id: "comic-container-wrapper",
  class: "comic-container-wrapper scroll"
};
const _hoisted_3 = {
  class: "success comic-container"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Scroll",
  class: "scroll"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Success comic page",
  class: "comic"
}, null, -1);
const _hoisted_6 = {
  class: "mint-more-container"
};
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"top-left corner-decoration\"></div><div class=\"top-right corner-decoration\"></div><div class=\"bottom-left corner-decoration\"></div><div class=\"bottom-right corner-decoration\"></div><p class=\"title\">View your NFTs</p>", 5);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://opensea.io/collection/kizunagenesis",
  class: "opensea-link link",
  target: "_blank"
}, [/*#__PURE__*/_createTextVNode(" OPENSEA "), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "New tab",
  class: "icon"
})], -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://blur.io/collection/0x7777777Be27646dA6603804cE7202224121a2482",
  class: "blur-link link",
  target: "_blank"
}, "BLUR", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://blur.io/collection/0x7777777Be27646dA6603804cE7202224121a2482",
  class: "blur-link link",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "New tab",
  class: "icon"
})], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_button, {
    text: true,
    link: true,
    onClick: _cache[0] || (_cache[0] = () => {}),
    class: "button"
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }), _createVNode(_component_el_button, {
    text: true,
    link: true,
    onClick: _cache[1] || (_cache[1] = () => {}),
    class: "button"
  }, {
    default: _withCtx(() => [_hoisted_13, _hoisted_14]),
    _: 1
  }), _createVNode(_component_el_button, {
    text: true,
    onClick: _cache[2] || (_cache[2] = () => _ctx.close()),
    class: "mint-more-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("MINT MORE")]),
    _: 1
  })])])])]);
}